import * as React from 'react';
import { C as Context, k as invariantIntlContext } from './injectIntl-0da7053c.js';

function useIntl() {
    var intl = React.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}

export { useIntl as u };
